import Axios from 'axios';
import { responseTransformInteceptor } from './response-transform-inteceptor';
import { securityInteceptor } from './security-interceptor';

export function configureAxios() {
    Axios.interceptors.request.use(securityInteceptor);
    Axios.interceptors.response.use(responseTransformInteceptor);
}
